import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiRP.get("/api/rp-workbench", { params });
};

const getAllForCSV = params => {
  return restApiRP.get("/api/rp-workbench/csv", { params });
};

const updateWorkbenchData = data => {
  return restApiRP.post("/api/rp-workbench/update", data);
}

const confirmVersion = data => {
  return restApiRP.post("/api/rp-workbench/confirm", data);
}

const rpWorkbenchService = {
  getAll,
  getAllForCSV,
  updateWorkbenchData,
  confirmVersion
};

export default rpWorkbenchService;